import {loadingDialog_show} from "../../../actions";
import {showErrorOnSave} from "../../FeaturesSetup/featuresAsyncActions";
import {updateJob} from "../JobBoardActions";
import {getParsedJobOrder} from "../jobPurchaseOrderPopup/jobOrderFunctions";


export const onSaveReferralProgramsClick = (closePopup, popupContext, intl) => {
  return async (dispatch, getState) => {
    console.log("popupContext", popupContext);
    dispatch(loadingDialog_show(true, 'Saving...', "Please wait while the associate is saved"));

    try {

      const jobOrder = getParsedJobOrder(popupContext.job); // jobOrderInterface

      const allRelationsResponse = await getApiConfig(`JobBoard/${popupContext.job.id}/relations`).get();

      if (Array.isArray(allRelationsResponse) && allRelationsResponse.length > 0) { // delete everything
        for (const relation of allRelationsResponse) {
          await getApiConfig(`JobBoard/${popupContext.job.id}/relation/${relation.id}`).delete()
        }
      }

      if (popupContext.childFabricatorId) {
        const response = await getApiConfig(`JobBoard/${popupContext.job.id}/relate/${popupContext.childFabricatorId}`).post();
        if ((!response && !Number.isInteger(response)) || response.error || response.__error__) { // response 0 is ok
          showErrorOnSave(dispatch, response, intl)
          return false
        }
      }

      jobOrder.parentFabricatorId = popupContext.job.fabricatorId;
      jobOrder.parentFabricatorName = popupContext.parentFabricatorName;
      jobOrder.childFabricatorId = popupContext.childFabricatorId;
      jobOrder.childFabricatorName = popupContext.childFabricatorName;
      jobOrder.referralPercent = popupContext.percentage;
      jobOrder.qcPercent = popupContext.qcPercentage;

      const response2 = await getApiConfig(`JobBoard/updateJobOrder/${popupContext.job.id}`).post(
        JSON.stringify(jobOrder)
      );
      if ((!response2 && !Number.isInteger(response2)) || response2.error || response2.__error__) { // response 0 is ok
        showErrorOnSave(dispatch, response2, intl)
        return false
      }
      dispatch(loadingDialog_show(false));

      dispatch(updateJob(popupContext.job, {
        jobOrder: JSON.stringify(jobOrder),
      }));
      closePopup();
      return true
    } catch (response) {
      console.log('error SaveReferral ->', response);
      dispatch(loadingDialog_show(false));
      showErrorOnSave(dispatch, response, intl);
      return false
    }
  }
}
